
import s from './Liked.module.scss';
import {ReactComponent as Like} from "./like.svg";

const Liked = () => {
    return (
        <Like/>
    );

}

export default Liked;